import { useEffect } from 'react';

import { setLastActive } from '../api/auth';
import { getApiToken } from '../helpers/helper';

const HEARTBEAT_CHECK_INTERVAL_MS = 10 * 60 * 1000;
const HEARTBEAT_THROTTLE_MS = 60 * 60 * 1000;
const STORAGE_KEY = 'PROVENANCE_LAST_HEARTBEAT';

const readLastHeartbeatAt = (): number => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
};

const writeLastHeartbeatAt = (timestamp: number) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(timestamp));
  } catch {}
};

const tick = () => {
  try {
    const token = getApiToken();
    if (!token) return;

    const last = readLastHeartbeatAt();
    if (Date.now() - last <= HEARTBEAT_THROTTLE_MS) return;

    writeLastHeartbeatAt(Date.now());
    void setLastActive();
  } catch {}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Heartbeat = (props: { children: any }) => {
  useEffect(() => {
    tick();

    const interval = setInterval(tick, HEARTBEAT_CHECK_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        tick();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return <>{props.children}</>;
};

export default Heartbeat;
